module.exports = __webpack_public_path__ + "dede1ec219d78158618030a784d41270.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/lambda-lambda-lambda.jpg
// module id = 266
// module chunks = 1